import React, { useEffect } from 'react';
import classnames from 'classnames/bind';
import { isEmpty, noop } from 'lodash';
import { ArrowBackIcon, Button } from 'tuui';
import { Divider } from 'taboola-ultimate-ui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { MainFilters } from './MainFilters/MainFilters';
import { SelectedFilters } from './SelectedFilters/SelectedFilters';
import { SubFilters } from './SubFilters/SubFilters';
import { useDropdownMenuFilters } from './hooks/useDropdownMenuFilters';
import styles from './dropdownMenuListWithHeader.module.scss';

const classNameBuilder = classnames.bind(styles);

export const createMenuListWithHeader =
    ({ filters = [], setSelectedFiltersWithSubFilters = noop, initialFilter = {} }) =>
    (props = { children: [] }) => {
        const {
            selectedFilter, // The main filter type -- ex) Type filter
            onSelectFilter,
            setSelectedFilter,
            getValuesForSelectedFilter,
            onSelectSubFilter,
            getSubFiltersForSelectedFilter,
            getSelectedFiltersFormMap,
            onclickSelectedFilter,
            onRemoveSelectedFilter,
            filteredChildren,
            setInitialFilter,
        } = useDropdownMenuFilters(props, setSelectedFiltersWithSubFilters, filters);

        useEffect(() => {
            setInitialFilter(initialFilter);
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

        const filtersToShow = !selectedFilter ? (
            <MainFilters
                filters={filters.map(filter => ({ name: filter.name, fieldName: filter.fieldName }))}
                onClick={onSelectFilter}
            />
        ) : (
            <SubFilters
                filters={getValuesForSelectedFilter(selectedFilter)}
                onClick={onSelectSubFilter}
                selectedSubFilters={getSubFiltersForSelectedFilter(selectedFilter)}
            />
        );

        const selectedFiltersToShow = getSelectedFiltersFormMap();

        return (
            <div className={styles['container']} aria-label="DropdownMenuListWithHeader">
                {selectedFilter && (
                    <div className={styles['back-button-container']}>
                        <Button
                            size={Button.size.sm}
                            variant={Button.variant.text}
                            onClick={() => setSelectedFilter(null)}
                            className={styles['back-button']}
                        >
                            <div className={styles['icon-container']}>
                                <ArrowBackIcon />
                            </div>
                            <div className={styles['filter-name-title']}>
                                <FormattedMessage
                                    id={`campaign.editor.targeting.my-audiences.${selectedFilter.fieldName}.filter.name`}
                                    defaultMessage="{detail}"
                                    values={{ detail: selectedFilter.name }}
                                />
                            </div>
                        </Button>
                    </div>
                )}
                {filtersToShow}
                <Divider
                    className={classNameBuilder(
                        'divider',
                        selectedFiltersToShow.length === 0 || selectedFilter ? styles['selected-filters'] : ''
                    )}
                />
                {!selectedFilter && (
                    <SelectedFilters
                        filters={getSelectedFiltersFormMap()}
                        onClick={onclickSelectedFilter}
                        onRemove={onRemoveSelectedFilter}
                    />
                )}
                {!isEmpty(filteredChildren) ? (
                    filteredChildren
                ) : (
                    <FormattedMessage
                        className={styles['no-options']}
                        id="app.dropdowns.no.options"
                        defaultMessage="No options"
                    />
                )}
            </div>
        );
    };
